module.exports = __webpack_public_path__ + "static/media/recharging-your-battery.bd6fd781.png";